import { useLang } from '@/i18n';
import EcoLink from 'eco-design/base/eco-link';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import css from './index.module.scss';

const O: React.FC = () => {
    const { t } = useLang('stream_ultra_x');
    const { locale = '' } = useRouter();
    const boxRef = useRef<HTMLDivElement>(null);
    const videoMap: { [key: string]: string } = {
        en: 'https://websiteoss.ecoflow.com/upload/video/1753865266538/15.mp4',
        de: 'https://websiteoss.ecoflow.com/upload/video/1754387346007/15_de.mp4',
    };
    const [load, setLoad] = useState(false);

    const imgMap: { [key: string]: string } = {
        en: 'https://websiteoss.ecoflow.com/upload/image/1754316325216/O_en.png',
        de: 'https://websiteoss.ecoflow.com/upload/image/1754316325228/O_de.png',
        fr: 'https://websiteoss.ecoflow.com/upload/image/1754316325227/O_fr.png',
        it: 'https://websiteoss.ecoflow.com/upload/image/1754316325216/O_it.png',
        es: 'https://websiteoss.ecoflow.com/upload/image/1754316325246/O_es.png',
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneO = AniContainer.create({
                triggerElement: '.stream-ultra-x-I',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                sceneO.destroy();
            };
        }
    }, []);

    useEffect(() => {
        if (!load || !boxRef.current) return;
        const playingVideo = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const video: HTMLVideoElement | null = document.querySelector('#stream-ultra-x-O video');
                    if (video && entry.isIntersecting) {
                        video.currentTime = 0;
                        video.play();
                    }
                });
            },
            {
                threshold: 0.5,
            },
        );
        playingVideo.observe(boxRef.current);
        return () => {
            playingVideo.disconnect();
        };
    }, [load]);

    return (
        <section
            className={`${css.section} stream-ultra-x-O GtmModuleData-section`}
            id="stream-ultra-x-O"
            ref={boxRef}
            data-section-id={'stream-ultra-x-O'}
            data-section-title={t('O_title')}
        >
            <div className="info">
                <p className="title">{t('O_title')}</p>
                <p className="desc">{t('O_desc')}</p>
            </div>
            <div className="video">
                {load && (
                    <video
                        src={videoMap[locale] || videoMap.en}
                        poster="https://websiteoss.ecoflow.com/upload/image/1754399756098/15_pc.jpg"
                        loop
                        // autoPlay
                        muted
                        playsInline
                        preload="auto"
                        width="100%"
                        height="100%"
                        aria-label={t('O_title')}
                    />
                )}
                <img className="img" src={imgMap[locale] || imgMap.en} width="100%" height="100%" aria-label={t('O_title')} loading="lazy" />
            </div>
            <p className="tip">{t('O_tip')}</p>
            <EcoLink
                className="link GtmModuleData-btn-href"
                href={`/${locale}/oasis-home-energy-management-system`}
                target="_self"
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'jump_button',
                    position: 'STREAM Ultra Series',
                    button_name: t('O_btn'),
                    url: `https://www.ecoflow.com/${locale}/oasis-home-energy-management-system`,
                    __btn_id1: `stream-ultra-x-O`,
                    __btn_id2: `/${locale}/oasis-home-energy-management-system`,
                    __btn_type: 'href',
                }}
            >
                <span>{t('O_btn')}</span>
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.75 6.5L16.25 13L9.75 19.5" stroke="white" stroke-width="1.625" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </EcoLink>
        </section>
    );
};

export default O;
